<template>
  <div v-if="subStatusLabel" :class="['sub-status', `sub-status--theme-${theme}`]">
    <div class="sub-status__contain">
      <span :class="['sub-status__status-circle', `sub-status__status-circle--status-${statusState}`]"></span>
      <span class="sub-status__label">{{ t(subStatusLabel) }}</span>
    </div>
  </div>
</template>

<script lang="ts">
import { WorkspaceSubStatus, WorkspaceTemplate } from "@/types/workspace"
import { defineComponent, PropType, computed } from "@vue/composition-api"
import { createTranslationModule } from "@/plugins/i18n"
import "../../scss/_sub-status.scss"

enum Theme {
  DEFAULT = "default",
  LIGHT = "light"
}

export default defineComponent({
  name: "SubStatusLabels",
  props: {
    workspace: {
      type: Object as PropType<WorkspaceTemplate>,
      required: true
    },
    theme: {
      type: String as PropType<`${Theme}`>,
      default: "default"
    }
  },
  setup(props) {
    const t = createTranslationModule("WorkspaceEdit.subStatus")

    const statusTypesMap = {
      [WorkspaceSubStatus.PrepareDeploying]: "deploy",
      [WorkspaceSubStatus.DeployStarted]: "deploy",
      [WorkspaceSubStatus.WaitingForDeployment]: "deploy",
      [WorkspaceSubStatus.DestroyingStarted]: "destroy",
      [WorkspaceSubStatus.WaitingForDestruction]: "destroy",
      [WorkspaceSubStatus.FinishingUpEverything]: "deploy"
    }

    const subStatusLabel = computed(() => {
      return props.workspace.subStatus as WorkspaceSubStatus
    })

    const statusState = computed(() => {
      return statusTypesMap[subStatusLabel.value] || "default"
    })

    return {
      t,
      statusState,
      subStatusLabel
    }
  }
})
</script>
